export default __webpack_public_path__ + "static/media/spain_flag.73907b24.png";